import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import "./HighlightedText.scss";

interface HighlightedTextProps {
    term: string;
    searchText: string;
}

const HighlightedText = (props: HighlightedTextProps) => {
    const [start, setStart] = useState('');
    const [highlighted, setHighlighted] = useState('');
    const [end, setEnd] = useState('');

    useEffect(() => {
        if (props.searchText !== undefined) {
            const term = props.term;
            const length = props.searchText.length;
            const index = term.toLowerCase().indexOf(props.searchText.toLowerCase());
            setStart(term.substring(0, index));
            setHighlighted(term.substring(index, index + length));
            setEnd(term.substring(index + length));
        }
    }, [props]);
    
    return (
        <Box className="outer">
            {start}<span className="hl">{highlighted}</span>{end}
        </Box>
    );
}

export default HighlightedText